module.exports = __webpack_public_path__ + "static/media/03.b4730623.jpg";